// extracted by mini-css-extract-plugin
export var textInput = "_dh-0";